<template>
    <section v-if="items && items.length" class="mt-10">
        <div class="mb-2 flex items-end justify-between gap-4 px-0.5">
            <div class="min-w-0">
                <h2 class="nl-section-title">{{ title }}</h2>
                <p v-if="subtitle" class="mt-0.5 text-sm text-nomad-400">{{ subtitle }}</p>
            </div>
            <Link v-if="href" :href="href" class="shrink-0 text-sm font-medium text-nomad-400 transition-colors hover:text-white">
                Show all
            </Link>
        </div>
        <div class="no-scrollbar -mx-2.5 flex snap-x overflow-x-auto">
            <div v-for="(item, index) in items" :key="itemKey(item, index)"
                class="shrink-0 snap-start" :class="itemClass">
                <slot :item="item" :index="index"></slot>
            </div>
        </div>
    </section>
</template>
<script>
import { Link } from "@inertiajs/vue3";
export default {
    name: "Shelf",
    components: { Link },
    props: {
        title: String,
        subtitle: String,
        href: String,
        items: { type: Array, default: () => [] },
        itemClass: { type: String, default: "w-[40vw] max-w-[11.5rem] sm:w-44 xl:w-48" },
    },
    methods: {
        itemKey(item, index) {
            return (item && (item.id ?? item.song_id)) ?? index;
        },
    },
};
</script>
